import * as React from "react";

import CycloneIcon from "@mui/icons-material/Cyclone";
import HospitalIcon from "@mui/icons-material/HealthAndSafety";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import ListIcon from "@mui/icons-material/List";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import WorkIcon from "@mui/icons-material/Work";
import ChatIcon from "@mui/icons-material/ChatBubbleOutline";
import ChatsIcon from "@mui/icons-material/Chat";
import MoneyIcon from "@mui/icons-material/Money";
import ExamIcon from "@mui/icons-material/AssignmentLate";
import MailIcon from "@mui/icons-material/Mail";
import DnsIcon from "@mui/icons-material/Dns";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ArticleIcon from "@mui/icons-material/Article";
import AbcIcon from "@mui/icons-material/Abc";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { Link, useLocation, useMatch } from "react-router-dom";
import { Collapse } from "@mui/material";

const mainListItems = [
  { text: "Home", icon: <HomeRoundedIcon />, to: "" },
  { text: "Şehirler", icon: <LocationCityIcon />, to: "/cities" },
  { text: "Hastaneler", icon: <HospitalIcon />, to: "/hospitals" },
  { text: "Atama Dönemleri", icon: <CycloneIcon />, to: "/assignment-periods" },
  {
    text: "Kullanıcılar",
    icon: <PeopleRoundedIcon />,
    to: "/users",
  },
  {
    text: "Loglar",
    icon: <ListIcon />,
    to: "/logs",
  },
  {
    text: "Email Logları",
    icon: <MailIcon />,
    to: "/emailLogs",
  },
  {
    text: "Mail Sunucuları",
    icon: <DnsIcon />,
    to: "/smtpAccounts",
  },
  {
    text: "Onaysız Kullanıcılar",
    icon: <MarkEmailUnreadIcon />,
    to: "/unconfirmedUsers",
  },
  { text: "Branşlar", icon: <WorkIcon />, to: "/professions" },
  { text: "Yazışmalar", icon: <ChatsIcon />, to: "/chats" },
  { text: "Sistem Mesajları", icon: <ChatIcon />, to: "/systemChats" },
  { text: "Satın Almalar", icon: <MoneyIcon />, to: "/purchases" },
];
const examListItems = [
  { text: "Sınavlar", icon: <ExamIcon />, to: "/exams" },
  { text: "Sınav Tipleri", icon: <AbcIcon />, to: "/examTypes" },
];

const secondaryListItems = [
  { text: "Settings", icon: <SettingsRoundedIcon /> },
  { text: "About", icon: <InfoRoundedIcon /> },
  { text: "Feedback", icon: <HelpRoundedIcon /> },
];

interface ListItemLinkProps {
  icon?: React.ReactElement<any>;
  text: string;
  to: string;
}
function ListItemLink(props: ListItemLinkProps) {
  const { icon, text, to } = props;
  const selected = useMatch(to);
  const location = useLocation();

  return (
    <ListItemButton
      component={Link}
      to={{ pathname: to }}
      state={{ text, from: location }}
      selected={!!selected}
    >
      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
      <ListItemText primary={text} />
    </ListItemButton>
  );
}
export default function MenuContent() {
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: "block" }}>
            <ListItemLink {...item} />
          </ListItem>
        ))}
        <ListItem disablePadding sx={{ display: "block" }}>
          <ListItemButton onClick={handleClick}>
            <ListItemIcon>
              <ArticleIcon />
            </ListItemIcon>
            <ListItemText primary="Sınav Yönetimi" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List dense>
            {examListItems.map((item, index) => (
              <ListItem key={index} disablePadding sx={{ display: "block" }}>
                <ListItemLink {...item} />
              </ListItem>
            ))}
          </List>
        </Collapse>
      </List>

      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: "block" }}>
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
